// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","container":"ThemeSwitcher__container--kF","label":"ThemeSwitcher__label--Oc","anchor":"ThemeSwitcher__anchor--RL"};